export enum DateRangeFilterType {
	lastWeek = "lastWeek",
	lastMonth = "lastMonth",
	lastYear = "lastYear",
	customDateRange = "customDateRange"
}

export enum TeamProgressWidget {
	completedCourses = "completedCourses",
	completedLessons = "completedLessons",
	timeInTraining = "timeInTraining",
	activeUsers = "activeUsers",
	inactiveUsers = "inactiveUsers",
	usersWithOverdueLessons = "usersWithOverdueLessons"
}

export enum TeamProgressSection {
	widgets = "widgets",
	chart = "chart",
	dataGrid = "dataGrid"
}